<script>
export default {
  name: 'dropdown-item-children',
  functional: true,
  props: {
    children: {
      default: () => ([Object.assign({component: '', data: ''})])
    }
  },
  render: function (h, context) {
    return (
      <div>
        {
          context.props.children.map(child => {
            return (<stateless-factory
              componentProp={child.component}
              dataProp={child.data}
            />)
          })
        }
      </div>
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Layout/DropdownItemChildren.vue